// A ptarmigan, modelled facing +X: a round white winter-plumage bird with a small
// red eye-comb and feathered feet. Ported 1:1 from age-of-mcp's classic
// ptarmigan.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.034, 0), color: "#f4f6f8",
      position: [0, 0.032, 0], scale: [1.3, 1.1, 1] },              // body
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#ffffff",
      position: [0.04, 0.06, 0] },                                   // head
    { geometry: new THREE.ConeGeometry(0.006, 0.014, 4), color: "#2a2a2a",
      position: [0.058, 0.058, 0], rotation: [0, 0, -Math.PI / 2] },   // beak
    { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#d83030",
      position: [0.038, 0.074, 0.012] },                            // red comb
    { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#d83030",
      position: [0.038, 0.074, -0.012] },
    { geometry: new THREE.ConeGeometry(0.012, 0.03, 4), color: "#e8eef2",
      position: [-0.04, 0.034, 0], rotation: [0, 0, Math.PI / 2], scale: [1, 1, 0.5] }, // tail
  ];
}

export const ptarmigan = defineModel({
  id: "ptarmigan",
  batchId: "standard",
  name: "Ptarmigan",
  tags: ["creature","ptarmigan","low-poly","age-of-mcp","classic"],
  summary: "Low-poly ptarmigan.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: () => partsFor(),
  animations: [],
});
